import React from "react";
import CompanyInfo from "../components/about/CompanyInfo";
import IntroHeroSection from "../components/about/IntroHeroSection";
import ApproachSection from "../components/about/ApproachSection";
import Clients from "../components/about/Clients";
import WhyChooseUs from "../components/about/WhyChooseUs";
import Achievements from "../components/about/Achievements";
import FAQSection from "../components/about/FAQSection";

const About = () => {
  return (
    <>
      <section className="relative w-full min-h-screen text-white overflow-hidden">
        <IntroHeroSection />
        <Achievements />
        <ApproachSection />
        <Clients />
        <WhyChooseUs />
        <FAQSection />
        <CompanyInfo />
      </section>
    </>

  );
};

export default About;
